import direccionClienteService from '../../../services/direccionClienteService';
import { pickDireccionLabel } from './planFormHelpers';
import { VisitRowState } from './planVisitaFormUi';

export const validateVisitRow = (row: VisitRowState, label = 'la visita'): string | null => {
  if (Number(row.nroCliente) <= 0) {
    return 'Seleccione un cliente.';
  }
  if (row.direccionLoading) {
    return `Espere a que carguen las direcciones de ${label}.`;
  }
  if (row.direcciones.length > 0 && !row.codigoDireccion.trim()) {
    return `Seleccione la dirección del cliente en ${label}.`;
  }
  return null;
};

export const loadDireccionesForVisitRow = async (
  nroCliente: number,
): Promise<Pick<VisitRowState, 'direcciones' | 'codigoDireccion' | 'direccionLabel' | 'direccionLoading'>> => {
  if (!nroCliente || nroCliente <= 0) {
    return {
      direcciones: [],
      codigoDireccion: '',
      direccionLabel: '',
      direccionLoading: false,
    };
  }

  try {
    const data = await direccionClienteService.getDirecciones(nroCliente);
    const direcciones = data || [];
    const autoPick = direcciones.length === 1 ? direcciones[0] : null;
    return {
      direcciones,
      direccionLoading: false,
      codigoDireccion: autoPick?.codigoDireccion || '',
      direccionLabel: autoPick ? pickDireccionLabel(autoPick) : '',
    };
  } catch {
    return {
      direcciones: [],
      codigoDireccion: '',
      direccionLabel: '',
      direccionLoading: false,
    };
  }
};
